import { useEffect, useRef } from 'react';
import { useLocation } from 'react-router-dom';
import { useAppDispatch } from '@store/hooks';
import { bootstrapSessionAsync } from '@store/slices/authSlice';

/**
 * After redux-persist rehydrates, restore the session (``POST /auth/refresh`` + Bearer ``/users/me``,
 * or cookie-only ``GET /users/me`` as fallback — see ``sessionBootstrap``). Skips ``/auth/callback``
 * so we do not run bootstrap before the OAuth code is exchanged.
 *
 * Bootstrap fires **exactly once per app session**. Earlier this effect re-ran on every
 * navigation (``pathname`` was in the deps), which yanked ``sessionBootstrapComplete`` back
 * to ``false`` via the ``.pending`` reducer and caused ProtectedRoute to flash
 * ``LoadingFallback`` after every successful login or SSO callback navigation.
 */
export function SessionBootstrap() {
  const dispatch = useAppDispatch();
  const { pathname } = useLocation();
  const hasRunRef = useRef(false);

  useEffect(() => {
    if (hasRunRef.current) return;
    if (pathname === '/auth/callback') return;
    hasRunRef.current = true;
    void dispatch(bootstrapSessionAsync());
  }, [dispatch, pathname]);

  return null;
}
